import { PermissionGroup } from "src/app/constants/settings.enum";
/**
 * Model for the Actor permissions to get the correct data from de PermissionClient
 */
export class PermissionModel {
    configurationGroup:PermissionGroup = PermissionGroup.Setting; 
    isDisabled:boolean = false;
    isHidden:boolean = false;
    isLocked:boolean = false;
    name!:string;
    positionInGroup: number = 999;
    value!:string;
    /** IF value is a boolean this translates to false/True. if not it will always be a false value */
    valueAsBoolean!:boolean;
    
}